/**
 * External Imports
 */
import { Dispatch, FC, SetStateAction } from 'react';

/**
 * Internal Imports
 */
import { Dropdown } from '../../../shared/dropdowns';

/**
 * Style Imports
 */
import { InputHeading, SCLogo } from './CategorySelect.styles';

/**
 * Static File Imports
 */
import serviceCentralLogoImg from '../../../../assets/images/service_central_icon.png';

/**
 * Constant Imports
 */
import serviceCentralCategories from '../../../../constants/serviceCentralCategories.json';

const CategorySelect: FC<{
  disabled?: boolean;
  heading: string;
  categoryName: string;
  categoryValue: string;
  placeholder: string;
  categories: string[];
  open: boolean;
  handleInputs: (value: string, name: string) => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}> = ({
  disabled,
  heading,
  categoryName,
  categories,
  categoryValue,
  placeholder,
  open,
  handleInputs,
  setOpen
}) => {
  return (
    <div id="Modal-Category-Select">
      <InputHeading>{heading}</InputHeading>
      <Dropdown
        classes="ps-0 pe-1"
        disabled={disabled}
        placeholder={categoryValue || placeholder}
        name={categoryName}
        open={open}
        setOpen={setOpen}
      >
        {categories.map((category: string) => (
          <div
            key={category}
            aria-selected={categoryValue === category}
            className={`dropdown-hover-item${
              categoryValue === category ? ' selected' : ''
            }`}
            role="option"
            tabIndex={0}
            onClick={() => handleInputs(category, 'category')}
            onKeyDown={() => handleInputs(category, 'category')}
          >
            <div className="d-flex align-items-center">
              {heading.includes('Issue') &&
                serviceCentralCategories.includes(category) && (
                  <SCLogo
                    width="25"
                    alt="service central logo"
                    src={serviceCentralLogoImg}
                  />
                )}
              {category}
            </div>
          </div>
        ))}
      </Dropdown>
    </div>
  );
};

export default CategorySelect;
